var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.3772,
    r: 13.5293,
    fill: "url(#paint0_linear_4229_8231)",
    stroke: "url(#paint1_linear_4229_8231)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9482 21.0363C14.0618 21.0363 13.2758 20.8848 12.5902 20.5817C11.9084 20.2749 11.3705 19.8526 10.9766 19.3147C10.5826 18.7768 10.3819 18.1575 10.3743 17.4567H13.2038C13.2152 17.7105 13.2966 17.9359 13.4482 18.1329C13.5997 18.3261 13.8061 18.4776 14.0675 18.5874C14.3288 18.6973 14.6262 18.7522 14.9595 18.7522C15.2929 18.7522 15.5864 18.6935 15.8402 18.5761C16.0978 18.4548 16.2985 18.2901 16.4425 18.0817C16.5864 17.8696 16.6565 17.6272 16.6527 17.3545C16.6565 17.0817 16.5788 16.8393 16.4197 16.6272C16.2607 16.4151 16.0353 16.2503 15.7436 16.1329C15.4557 16.0155 15.1148 15.9567 14.7209 15.9567H13.5902V13.9567H14.7209C15.0656 13.9567 15.3686 13.8999 15.63 13.7863C15.8951 13.6727 16.1016 13.5136 16.2493 13.309C16.397 13.1007 16.469 12.862 16.4652 12.5931C16.469 12.3317 16.4065 12.1026 16.2777 11.9056C16.1527 11.7048 15.9766 11.5495 15.7493 11.4397C15.5258 11.3298 15.2663 11.2749 14.9709 11.2749C14.6603 11.2749 14.3781 11.3298 14.1243 11.4397C13.8743 11.5495 13.6754 11.7048 13.5277 11.9056C13.38 12.1064 13.3023 12.3393 13.2947 12.6045H10.6072C10.6148 11.9113 10.808 11.3014 11.1868 10.7749C11.5656 10.2446 12.0807 9.82985 12.7322 9.53061C13.3875 9.23136 14.1338 9.08174 14.9709 9.08174C15.8042 9.08174 16.5372 9.22758 17.1697 9.51924C17.8023 9.81091 18.2947 10.2086 18.647 10.7124C18.9993 11.2124 19.1754 11.7787 19.1754 12.4113C19.1792 13.0666 18.9652 13.6064 18.5334 14.0306C18.1054 14.4548 17.5542 14.7162 16.88 14.8147V14.9056C17.7815 15.0117 18.4614 15.3033 18.9197 15.7806C19.3819 16.2579 19.611 16.8545 19.6072 17.5704C19.6072 18.2446 19.4084 18.8431 19.0107 19.3658C18.6167 19.8848 18.0675 20.2939 17.3629 20.5931C16.6622 20.8886 15.8572 21.0363 14.9482 21.0363Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4229_8231",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008F27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4229_8231",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006615"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank3);
export default __webpack_public_path__ + "static/media/rank3.85b72f48c352a61d73b29fede5a9105e.svg";
export { ForwardRef as ReactComponent };